import { MediaCategory } from "@/interfaces/MediaCategory";
import ApiService from "./api.service";
import axios from "@/configs/axios";

interface CreateT {
  name: string;
}

interface UpdateT {
  name: string;
}

export class MediaCategoryService extends ApiService<
  MediaCategory,
  CreateT,
  UpdateT,
  never
> {
  constructor() {
    super("media-categories");
  }

  async listAll(): Promise<MediaCategory[]> {
    const res = await axios.get("media-categories");
    return res.data;
  }
}
